import { Button } from '@/components/atoms'
import { SaveReportContent } from '@/components/molecules/SaveReportContent/SaveReportContent'
import { GetSustainabilityTotalEmissionsRequestParams } from '@/hooks'
import { useGlobalModalStore } from '@/stores/useGlobalModalStore/useGlobalModalStore'
import { useTranslation } from 'react-i18next'
import { TotalEmissionsExportDropdown } from '../../TotalEmissionsExportDropdown/TotalEmissionsExportDropdown'

export type TotalEmissionsActionsProps = {
    filters: GetSustainabilityTotalEmissionsRequestParams
}

export const TotalEmissionsActions: React.FC<TotalEmissionsActionsProps> = ({
    filters,
}) => {
    const { t } = useTranslation('translations')

    const setModalState = useGlobalModalStore((state) => state.setModalState)
    const closeModal = () => {
        setModalState({ isOpen: false })
    }

    const labels = {
        saveButton: t('reporting.save_report.save_report_modal.save_button'),
        loadingSaveButton: t(
            'reporting.save_report.save_report_modal.loading_save_button'
        ),
    }

    const handleClickSaveReport = () => {
        setModalState({
            isOpen: true,
            title: t('reporting.save_report.save_report_modal.title'),
            description: t(
                'reporting.save_report.save_report_modal.description'
            ),
            content: () => (
                <SaveReportContent
                    reportType="total-emissions"
                    labels={labels}
                />
            ),
            onClose: closeModal,
        })
    }

    return (
        <div className="flex gap-4">
            <Button
                name="saveReport"
                size="large"
                variant="outlinePrimary"
                onClick={handleClickSaveReport}
                className="font-medium"
            >
                {t('common.save_report')}
            </Button>
            <TotalEmissionsExportDropdown filters={filters} />
        </div>
    )
}
